import { Validators } from '@quickbit/qb-design-system';
import { ThemeOverride } from '../../useSitesApi';

const validateColor = (value: string) => {
  // check that it's a hex starting with # and 6 characters long
  if (value && !/^#[0-9A-Fa-f]{6}$/.test(value)) {
    return 'Must be a valid hex color code';
  }
};

const validatePixels = (value: string) => {
  // check that it's a number followed by px
  console.log('Validating pixels:', value);
  if (value && !/^\d+px$/.test(value)) {
    console.log('Validating pixels WRONG:', value);
    return 'Must be a valid pixel value (e.g., 16px)';
  }
};

export const themeValidators: Validators<ThemeOverride, ThemeOverride> = {
  content: {
    companyName: (value) => {
      if (!value || value.trim() === '') {
        return 'Company name is required';
      }
    },
  },
  theme: {
    core: {
      shape: {
        borderRadius: validatePixels,
        buttonRadius: validatePixels,
      },
      palette: {
        background: validateColor,
        primary: {
          x50: validateColor,
          x200: validateColor,
          default: validateColor,
          x700: validateColor,
        },
        secondary: {
          x50: validateColor,
          x200: validateColor,
          default: validateColor,
          x700: validateColor,
        },
        border: validateColor,
        grey: {
          x50: validateColor,
          x200: validateColor,
          default: validateColor,
          x700: validateColor,
        },
        black: validateColor,
      },
    },
  },
};
